import axios from "axios"
import { toast } from "react-toastify"

const fetchPasswordResetRequest = () => {
	return {type: "FETCH_PASSWORD_RESET_REQUEST"}
}

const fetchPasswordResetSuccess = (new_password) => {
	return {type: "FETCH_PASSWORD_RESET_SUCCESS", payload: new_password}
}

const fetchPasswordResetFailure = (error) => {
	return {type: "FETCH_PASSWORD_RESET_FAILURE", payload: error}
}

export const fetchResetPassword = (data) => {
	return (dispatch) => {
		dispatch(fetchPasswordResetRequest())
		axios.put(`user/password`, data)
		.then(response => {
			if(response.status && response.status === 200) {
				const new_password = response.data
				dispatch(fetchPasswordResetSuccess(new_password))	
				toast.dismiss()	
				toast.success("با موفقیت انجام شد" , {position: 'bottom-right',className: 'foo-bar'})
			} else {
				toast.dismiss()
				toast.error("مشکلی پیش آمده است" , {position: 'bottom-right',className: 'foo-bar'})	
			}
		})
		.catch(err => {
			if(err.response && err.response.status === 422) {
				dispatch(fetchPasswordResetFailure(err))	
				toast.dismiss()
				toast.error("رمز عبور فعلی وارد شده صحیح نیست" , {position: 'bottom-right',className: 'foo-bar'})
			}
		})
	}
}
